'use strict';

import successStripesTemplate from './successStripes.directive.html';
import './successStripes.directive.scss';

export default angular
  .module('maestro.directives.components.success-stripes', [])
  .directive('successStripes', () => {
      return {
        restrict: 'E',
        template: successStripesTemplate,
        scope: {
          history: '=history',
        },
      };
    }
  )

  .name;
